import React from 'react'
import Relay from 'react-relay'
import moment from 'moment'
import {cloneDeep} from 'lodash'

import RelayStore from '../RelayStore';
import { appStyles, colors, fonts } from '../theme'
import Button from './Button';

import NewLockerMutation from '../mutations/Venue/NewLockerMutation'
import NewLightGroupMutation from '../mutations/Venue/NewLightGroupMutation';
import NewMusicPlayerMutation from '../mutations/Venue/NewMusicPlayerMutation';
import UpdateLockerMutation from '../mutations/Venue/UpdateLockerMutation'
import UpdateLightGroupMutation from '../mutations/Venue/UpdateLightGroupMutation';
import UpdateMusicPlayerMutation from '../mutations/Venue/UpdateMusicPlayerMutation';
import DeleteLockerMutation from '../mutations/Venue/DeleteLockerMutation'
import DeleteLightGroupMutation from '../mutations/Venue/DeleteLightGroupMutation';
import DeleteMusicPlayerMutation from '../mutations/Venue/DeleteMusicPlayerMutation';
import UnlockLockerMutation from '../mutations/Venue/UnlockLockerMutation';
import LockLockerMutation from '../mutations/Venue/LockLockerMutation';
import TurnOnLightGroupMutation from '../mutations/Venue/TurnOnLightGroupMutation';
import TurnOffLightGroupMutation from '../mutations/Venue/TurnOffLightGroupMutation';

const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']; 

const Infrastructures = ({ infrastructures }) =>
    <table className="table table-hover table-condensed">
        <thead>
            <tr>
                <th>Name</th>
                <th>Most Active Circles</th>
                <th>Current sportunity</th>
                <th>Next sportunity</th>
            </tr>
        </thead>
        <tbody>
            {infrastructures.map((infrastructure, index) => (
                <tr
                    key={index}
                >
                    <td>
                        {infrastructure.name}
                    </td>
                    <td>
                        {infrastructure.most_active_circles && infrastructure.most_active_circles.length > 0
                        ?   infrastructure.most_active_circles.filter((item, index) => index < 3).map(item => item.circle.name).join(', ')
                        :   'none'
                        }
                    </td>
                    <td>
                        {infrastructure.currentSportunity 
                        ?   `${infrastructure.currentSportunity.title} by ${infrastructure.currentSportunity.organizers.find(o => o.isAdmin).organizer.pseudo} until ${moment(infrastructure.currentSportunity.ending_date).format('HH:mm')}`
                        :   'Nothing ongoing'
                        }
                    </td>
                    <td>
                        {infrastructure.nextSportunity 
                        ?   `${infrastructure.nextSportunity.title} by ${infrastructure.nextSportunity.organizers.find(o => o.isAdmin).organizer.pseudo} on ${moment(infrastructure.nextSportunity.beginning_date).format('DD/MM')} from ${moment(infrastructure.nextSportunity.beginning_date).format('HH:mm')} to ${moment(infrastructure.nextSportunity.ending_date).format('HH:mm')}`
                        :   'Nothing incoming'
                        }
                    </td>
                </tr>
            ))}
        </tbody>
    </table>

const Lockers = ({ lockers, editLocker, isFormOpen, formContent, infrastructures, onValidateForm = () => {}, onUpdateField = () => {}, onCloseNewForm = () => {}, onDelete = () => {}, action = () => {} }) =>
    <table className="table table-hover table-condensed">
        <thead>
            <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {lockers.map((locker, index) => (
                isFormOpen && formContent.id === locker.id 
                ?   <div>
                        <Form
                            kind={"locker"}
                            infrastructures={infrastructures}
                            onValidate={onValidateForm}
                            onUpdateField={onUpdateField}
                            onClose={onCloseNewForm}
                            formContent={formContent}
                            onDelete={() => onDelete(locker.id)}
                        />
                    </div>
                : <tr
                        key={index}
                        onClick={() => editLocker(locker)}
                    >
                        <td>
                            {locker.name}
                        </td>
                        <td className={locker.status === 'LOCKED' ? 'text-danger' : 'text-success'}>
                            {locker.status}
                        </td>
                        <td>
                            {locker.status === 'LOCKED'
                            ?   <button type="submit" className="btn btn-primary" onClick={event => action(locker.id, 'unlock', event)}>Unlock</button>
                            :   <button type="submit" className="btn btn-success" onClick={event => action(locker.id, 'lock', event)}>Lock</button>
                            }
                        </td>
                    </tr>
            ))}
        </tbody>
    </table>

const LightGroups = ({ lightGroups, editLightGroup, isFormOpen, formContent, infrastructures, onValidateForm = () => {}, onUpdateField = () => {}, onCloseNewForm = () => {}, onDelete = () => {}, action = () => {} }) =>
    <table className="table table-hover table-condensed">
        <thead>
            <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {lightGroups.map((lightGroup, index) => (
                isFormOpen && formContent.id === lightGroup.id 
                ?   <div>
                        <Form
                            kind={"lightgroup"}
                            infrastructures={infrastructures}
                            onValidate={onValidateForm}
                            onUpdateField={onUpdateField}
                            onClose={onCloseNewForm}
                            formContent={formContent}
                            onDelete={() => onDelete(lightGroup.id)}
                        />
                    </div>
                :   <tr
                        key={index}
                        onClick={() => editLightGroup(lightGroup)}
                    >
                        <td>
                            {lightGroup.name}
                        </td>
                        <td className={lightGroup.status === 'ON' ? 'text-success' : 'text-danger'}>
                            {lightGroup.status}
                        </td>
                        <td>
                            {lightGroup.status === 'OFF'
                            ?   <button type="submit" className="btn btn-primary" onClick={event => action(lightGroup.id, 'turnon', event)}>Turn on</button>
                            :   <button type="submit" className="btn btn-success" onClick={event => action(lightGroup.id, 'turnoff', event)}>Turn off</button>
                            }
                        </td>
                    </tr>
            ))}
        </tbody>
    </table>

const MusicPlayers = ({ musicPlayers, editMusicPlayer, isFormOpen, formContent, infrastructures, onValidateForm = () => {}, onUpdateField = () => {}, onCloseNewForm = () => {}, onDelete = () => {}, action = () => {} }) =>
    <table className="table table-hover table-condensed">
        <thead>
            <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {musicPlayers.map((musicPlayer, index) => (
                isFormOpen && formContent.id === musicPlayer.id 
                ?   <div>
                        <Form
                            kind={"musicplayer"}
                            infrastructures={infrastructures}
                            onValidate={onValidateForm}
                            onUpdateField={onUpdateField}
                            onClose={onCloseNewForm}
                            formContent={formContent}
                            onDelete={() => onDelete(musicPlayer.id)}
                        />
                    </div>
                :   <tr
                        key={index}
                        onClick={() => editMusicPlayer(musicPlayer)}
                    >
                        <td>
                            {musicPlayer.name}
                        </td>
                        <td className={musicPlayer.status === 'ON' ? 'text-success' : 'text-danger'}>
                            {musicPlayer.status}
                        </td>
                        <td>
                            {musicPlayer.status === 'OFF'
                            ?   <button type="submit" className="btn btn-primary" onClick={event => action(musicPlayer.id, 'turnon', event)}>Turn on</button>
                            :   <button type="submit" className="btn btn-success" onClick={event => action(musicPlayer.id, 'turnoff', event)}>Turn off</button>
                            }
                        </td>
                    </tr>
            ))}
        </tbody>
    </table>

const Field = ({ title, content, infrastructures, displayNewButton = false, onNewButtonPress = () => {}, isFormOpen = false, onValidateForm = () => {}, onUpdateField = () => {}, onCloseNewForm = () => {}, formContent, kind}) =>
    <div style={{paddingBottom:20, paddingTop:10, paddingLeft:20}}>
        <div style={{display: 'flex',flexDirection:'row'}}>
            <label style={{paddingLeft:5, flex: 1}}>{title} :</label>
            <div style={{paddingLeft:20, flex: 8}}>
                {content}
            </div>
        </div>
        {displayNewButton &&
            <Button
                onClick={onNewButtonPress}
                style={{backgroundColor: colors.lightGreen, color: colors.white}}
                text={"New"}
            />    
        }
        {isFormOpen && !formContent.id &&
            <Form
                infrastructures={infrastructures}
                onValidate={onValidateForm}
                onUpdateField={onUpdateField}
                onClose={onCloseNewForm}
                kind={kind}
            />
        }
    </div>

const Form = ({kind, infrastructures, onValidate, onUpdateField, onClose, onDelete, formContent = {}}) => 
    <form style={{margin: '20px 0px'}}>
        <div className="form-group">
            <label for="deviceName">Name</label>
            <input type="text" className="form-control" id="deviceName" defaultValue={formContent.name} onChange={event => onUpdateField('name', event)}/>
        </div>

        <div className="form-group">
            <label for="deviceDescription">Description</label>
            <input type="text" className="form-control" id="deviceDescription" defaultValue={formContent.description} onChange={event => onUpdateField('description', event)}/>
        </div>

        <div className="form-group">
            <label for="deviceExternalId">External ID</label>
            <input type="text" className="form-control" id="deviceExternalId" defaultValue={formContent.externalId} onChange={event => onUpdateField('externalId', event)}/>
        </div>

        {kind === 'lightgroup' && 
            <div className="form-group">
                <input type="checkbox" className="custom-control-input" id="deviceAllowUserAccess" checked={formContent.allowUserAccess} onChange={event => onUpdateField('allowUserAccess', event)}/>
                <label className="custom-control-label" for="deviceAllowUserAccess" style={{marginLeft: 5}}>Let the user access this device</label>
            </div>
        }
      
        {kind === 'musicplayer' && 
            <div className="form-group">
                <label for="deviceMaximumVolume">Maximum volume</label>
                <input type="number" className="form-control" id="deviceMaximumVolume" defaultValue={formContent.maximumVolume} onChange={event => onUpdateField('maximumVolume', event)}/>
            </div>
        }
        
        {/* {kind === 'locker' && 
            <div>
                <div className="form-group">
                    <input type="checkbox" className="custom-control-input" id="deviceAccessControl" checked={formContent.accessControl.enableNoAccessControl} onChange={event => onUpdateField('accessControl.enableNoAccessControl', event)}/>
                    <label className="custom-control-label" for="deviceAccessControl">  Turn on NO-ACCESS-CONTROL (be careful not to let the door open)</label>
                </div>
                
                {weekdays.map((day, index) => 
                    <div className="col-xs-1">
                        <div className="form-group">
                            <label className="custom-control-label" for="deviceAllowUserAccess">{day}</label>
                            <input type="checkbox" className="custom-control-input" id="deviceAllowUserAccess" checked={formContent.allowUserAccess} onChange={event => onUpdateField('allowUserAccess', event)}/>
                        </div>
                    </div>
                )}
            </div>
        } */}

        <div className="row">
            <div className="col-xs-4">
                <div className="form-group">
                    <label for="deviceAccessBefore">Access before event (minutes)</label>
                    <input type="number" className="form-control" id="deviceAccessBefore" defaultValue={formContent.accessBefore} onChange={event => onUpdateField('accessBefore', event)}/>
                </div>
            </div>

            <div className="col-xs-4">
                <div className="form-group">
                    <label for="deviceAccessAfter">Access after event (minutes)</label>
                    <input type="number" className="form-control" id="deviceAccessAfter" defaultValue={formContent.accessAfter} onChange={event => onUpdateField('accessAfter', event)}/>
                </div>
            </div>
        </div>

        <select multiple className="custom-select my-1 mr-sm-2" id="deviceInfrastructures" defaultValue={formContent.infrastructures} onChange={event => onUpdateField('infrastructures', event)}>
            <option selected>Infrastructures...</option>
            {infrastructures.map((infra, index) => <option value={infra.id} key={index}>{infra.name}</option>)}
        </select>

        <div className="row" style={{marginTop: 20}}>
            <div className="col-xs-4">
                {formContent && formContent.id &&
                    <button className="btn btn-danger" onClick={onDelete}>Delete</button>
                }
            </div>

            <div className="col-xs-4">
                <button className="btn btn-warning" onClick={onClose}>Close</button>
            </div>

            <div className="col-xs-4">
                <button type="submit" className="btn btn-success" onClick={onValidate}>Submit</button>
            </div>
        </div>
    </form>
    
class VenuePanel extends React.Component {
    constructor() {
        super();

        this.state = {
            isLockerFormOpen: false,
            isLightGroupFormOpen: false,
            isMusicPlayerFormOpen: false,
            formContent: {}
        }
    }

    onValidateForm = (type) => {
        if (this.validateFormContent()) {
            const {viewer} = this.props;
            const formContent = this.state.formContent

            let mutation,   
                params = {
                    name: formContent.name,
                    description: formContent.description, 
                    venue: this.props.venue.id, 
                    externalId: formContent.externalId,
                    infrastructures: formContent.infrastructures,
                    accessMinutes: {
                        before: formContent.accessBefore,
                        after: formContent.accessAfter
                    },
                    ...(type === 'lightgroup' && {allowUserAccess: formContent.allowUserAccess}),
                    ...(type === 'locker' && {accessControl: formContent.accessControl}),
                    ...(type === 'musicplayer' && {maximumVolume: formContent.maximumVolume})
                }; 

            if (type === "locker") {
                if (params.accessControl && params.accessControl.__dataID__) 
                    delete params.accessControl.__dataID__;
                if (params.accessControl && params.accessControl.automaticNoAccessControl && params.accessControl.automaticNoAccessControl.__dataID__)
                    delete params.accessControl.automaticNoAccessControl.__dataID__;

                if (formContent.id)
                    mutation = new UpdateLockerMutation({locker: params, lockerId: formContent.id, viewer})
                else
                    mutation = new NewLockerMutation({locker: params, viewer});
            }
            else if (type === "lightgroup") {
                if (params.allowUserAccess && params.allowUserAccess.__dataID__) 
                    delete params.allowUserAccess.__dataID__;

                if (formContent.id)
                    mutation = new UpdateLightGroupMutation({lightGroup: params, lightGroupId: formContent.id, viewer});
                else
                    mutation = new NewLightGroupMutation({lightGroup: params, viewer});
            }
            else if (type === "musicplayer") {
                if (params.maximumVolume && params.maximumVolume.__dataID__) 
                    delete params.maximumVolume.__dataID__;

                if (formContent.id)
                    mutation = new UpdateMusicPlayerMutation({musicPlayer: params, musicPlayerId: formContent.id, viewer});
                else
                    mutation = new NewMusicPlayerMutation({musicPlayer: params, viewer});
            }

            if (mutation) {
                RelayStore.commitUpdate( mutation, {
                    onFailure: (error) => {
                        console.log('error', error.getError());
                        alert(formContent.id ? 'Update failed' : 'Add Failed')
                    },
                    onSuccess: (response) => {
                        console.log('success', response);
                        
                        this.props.refetchData(() => {
                            alert(formContent.id ? 'Update Success' : 'Add Success');
                            this.setState({
                                isLockerFormOpen: false,
                                isLightGroupFormOpen: false,
                                isMusicPlayerFormOpen: false,
                                formContent: {}
                            })
                        });
                    }
                });
            }
        }
        else {
            alert('Please check the form content')
        }
    }

    validateFormContent = () => {
        let formContent = cloneDeep(this.state.formContent);

        return true; 
    }

    onUpdateField = (field, event) => {
        let formContent = cloneDeep(this.state.formContent);
        formContent[field] = (field === 'allowUserAccess') ? event.target.checked : event.target.value;
        this.setState({formContent})
    }

    editLightGroup = lightGroup => {
        this.setState({
            isLockerFormOpen: false,
            isLightGroupFormOpen: true,
            formContent: {
                id: lightGroup.id,
                name: lightGroup.name, 
                description: lightGroup.description, 
                externalId: lightGroup.externalId,
                infrastructures: lightGroup.infrastructures.map(i => i.id),
                accessBefore: lightGroup.accessMinutes.before,
                accessAfter: lightGroup.accessMinutes.after,
                allowUserAccess: lightGroup.allowUserAccess
            }
        })
    }

    editMusicPlayer = musicPlayer => {
        this.setState({
            isLockerFormOpen: false,
            isMusicPlayerFormOpen: true,
            formContent: {
                id: musicPlayer.id,
                name: musicPlayer.name, 
                description: musicPlayer.description, 
                externalId: musicPlayer.externalId,
                infrastructures: musicPlayer.infrastructures.map(i => i.id),
                accessBefore: musicPlayer.accessMinutes.before,
                accessAfter: musicPlayer.accessMinutes.after,
                allowUserAccess: musicPlayer.allowUserAccess,
                maximumVolume: musicPlayer.maximumVolume
            }
        })
    }

    editLocker = locker => {
        this.setState({
            isLockerFormOpen: true,
            isLightGroupFormOpen: false,
            formContent: {
                id: locker.id,
                name: locker.name, 
                description: locker.description, 
                externalId: locker.externalId,
                infrastructures: locker.infrastructures.map(i => i.id),
                accessBefore: locker.accessMinutes.before,
                accessAfter: locker.accessMinutes.after,
                accessControl: locker.accessControl
            }
        })
    }

    onDelete = (type, id) => {
        let mutation,
            viewer = this.props.viewer ;

        if (type === "locker") {
            mutation = new DeleteLockerMutation({lockerId: id, viewer})
        }
        else if (type === "lightgroup") {
            mutation = new DeleteLightGroupMutation({lightGroupId: id, viewer});
        }
        else if (type === "musicplayer") {
            mutation = new DeleteMusicPlayerMutation({musicPlayerId: id, viewer});
        }

        if (mutation) {
            RelayStore.commitUpdate( mutation, {
                onFailure: (error) => {
                    console.log('error', error.getError());
                    alert('Delete Failed')
                },
                onSuccess: (response) => {
                    console.log('success', response);
                    
                    this.props.refetchData(() => {
                        alert('Successfully Deleted');
                        this.setState({
                            isLockerFormOpen: false,
                            isLightGroupFormOpen: false,
                            formContent: {}
                        })
                    });
                }
            });
        }
    }

    actionDevice = (type, id, action, event) => {
        event.stopPropagation(); 
        event.preventDefault();

        let mutation,
            viewer = this.props.viewer,
            params = type === 'locker' ? {lockerId: id, viewer} : {lightGroupId: id, viewer} ;

        if (type === 'locker') {
            if (action === 'lock') {
                mutation = new LockLockerMutation(params);
            }
            else if (action === 'unlock') {
                mutation = new UnlockLockerMutation(params);
            }
        }
        else if (type === 'lightgroup') {
            if (action === 'turnon') {
                mutation = new TurnOnLightGroupMutation(params);
            }
            else if (action === 'turnoff') {
                mutation = new TurnOffLightGroupMutation(params);
            }
        }

        if (mutation) {
            RelayStore.commitUpdate( mutation, {
                onFailure: (error) => {
                    console.log('error', error.getError());
                    alert('Action Failed')
                },
                onSuccess: (response) => {
                    console.log('success', response);
                    
                    this.props.refetchData(() => {
                        alert('Action Successfull');
                    });
                }
            });
        }
    }

    render() {
        const { venue: { name, lockers, isConnected, lightGroups, infrastructures, musicPlayers }, venue, relay } = this.props ;

        return (
            <div>
                <Field
                    title="Name"
                    content={name}
                />
                <Field
                    title="Infrastructures"
                    content={<Infrastructures infrastructures={infrastructures} />}
                />
                {isConnected && 
                    <Field
                        title="Lockers"
                        kind={"locker"}
                        content={
                            <Lockers 
                                lockers={lockers} 
                                editLocker={this.editLocker}
                                infrastructures={infrastructures}
                                isFormOpen={this.state.isLockerFormOpen}
                                onValidateForm={() => this.onValidateForm('locker')}
                                onCloseNewForm={() => this.setState({isLockerFormOpen: false, formContent: {}})}
                                onUpdateField={this.onUpdateField}
                                formContent={this.state.formContent}
                                onDelete={id => this.onDelete('locker', id)}
                                action={(id, action, event) => this.actionDevice('locker', id, action, event)}
                            />
                        }
                        infrastructures={infrastructures}
                        displayNewButton={!this.state.isLockerFormOpen && !this.state.isLightGroupFormOpen && !this.state.isMusicPlayerFormOpen}
                        onNewButtonPress={() => this.setState({isLockerFormOpen: true, isLightGroupFormOpen: false, isMusicPlayerFormOpen: false})}
                        isFormOpen={this.state.isLockerFormOpen}
                        onValidateForm={() => this.onValidateForm('locker')}
                        onCloseNewForm={() => this.setState({isLockerFormOpen: false, formContent: {}})}
                        onUpdateField={this.onUpdateField}
                        formContent={this.state.formContent}
                    />
                }
                {isConnected && 
                    <Field
                        title="Light groups"
                        kind={"lightgroup"}
                        content={
                            <LightGroups 
                                lightGroups={lightGroups} 
                                editLightGroup={this.editLightGroup}
                                infrastructures={infrastructures}
                                isFormOpen={this.state.isLightGroupFormOpen}
                                onValidateForm={() => this.onValidateForm('lightgroup')}
                                onCloseNewForm={() => this.setState({isLightGroupFormOpen: false, formContent: {}})}
                                onUpdateField={this.onUpdateField}
                                formContent={this.state.formContent}
                                onDelete={id => this.onDelete('lightgroup', id)}
                                action={(id, action, event) => this.actionDevice('lightgroup', id, action, event)}
                            />
                        }
                        infrastructures={infrastructures}
                        displayNewButton={!this.state.isLockerFormOpen && !this.state.isLightGroupFormOpen && !this.state.isMusicPlayerFormOpen}
                        onNewButtonPress={() => this.setState({isLightGroupFormOpen: true, isLockerFormOpen: false, isMusicPlayerFormOpen: false})}
                        isFormOpen={this.state.isLightGroupFormOpen}
                        onValidateForm={() => this.onValidateForm('lightgroup')}
                        onCloseNewForm={() => this.setState({isLightGroupFormOpen: false, formContent: {}})}
                        onUpdateField={this.onUpdateField}
                        formContent={this.state.formContent}
                    />
                }
                {isConnected && 
                    <Field
                        title="Music players"
                        kind={"musicplayer"}
                        content={
                            <MusicPlayers 
                                musicPlayers={musicPlayers} 
                                editMusicPlayer={this.editMusicPlayer}
                                infrastructures={infrastructures}
                                isFormOpen={this.state.isMusicPlayerFormOpen}
                                onValidateForm={() => this.onValidateForm('musicplayer')}
                                onCloseNewForm={() => this.setState({isMusicPlayerFormOpen: false, formContent: {}})}
                                onUpdateField={this.onUpdateField}
                                formContent={this.state.formContent}
                                onDelete={id => this.onDelete('musicplayer', id)}
                                action={(id, action, event) => this.actionDevice('musicplayer', id, action, event)}
                            />
                        }
                        infrastructures={infrastructures}
                        displayNewButton={!this.state.isLockerFormOpen && !this.state.isLightGroupFormOpen && !this.state.isMusicPlayerFormOpen}
                        onNewButtonPress={() => this.setState({isMusicPlayerFormOpen: true, isLockerFormOpen: false, isLightGroupFormOpen: false})}
                        isFormOpen={this.state.isMusicPlayerFormOpen}
                        onValidateForm={() => this.onValidateForm('musicplayer')}
                        onCloseNewForm={() => this.setState({isMusicPlayerFormOpen: false, formContent: {}})}
                        onUpdateField={this.onUpdateField}
                        formContent={this.state.formContent}
                    />
                }
            </div>
        )
    }
}

const styles = {
    list: {
		width: '100%',
	},
	listItem: {
		paddingBottom: 10,
		color: '#515151',
		fontSize: 16,
		fontWeight: 500,
		fontFamily: 'Lato',
    borderTopWidth: 0,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	icon: {
        display: 'inline-block',
        width: 38,
        height: 38,
        margin: '5px 13px 0 32px',
    },
	smallIcon: {
        display: 'inline-block',
        width: 24,
        height: 24,
        margin: 10,
    },
}

export default Relay.createContainer(VenuePanel, {
  initialVariables: {
    messagesSize: 20,
  },
  fragments: {
    venue: () => Relay.QL`
        fragment on Venue {
            id,
            name,
            isConnected,
            lockers {
                id, 
                name,
                description,
                status,
                accessMinutes {
                    before, 
                    after
                },
                externalId,
                infrastructures {
                    id
                },
                accessControl {
                    enableNoAccessControl,
                    automaticNoAccessControl {
                        monday {
                            from, 
                            to
                        },
                        tuesday {
                            from, 
                            to
                        },
                        wednesday {
                            from, 
                            to
                        },
                        thursday {
                            from, 
                            to
                        },
                        friday {
                            from, 
                            to
                        },
                        saturday {
                            from, 
                            to
                        },
                        sunday {
                            from, 
                            to
                        }
                    }
                }
            },
            lightGroups {
                id,
                name, 
                description,
                status,
                accessMinutes {
                    before, 
                    after
                },
                allowUserAccess,
                externalId,
                infrastructures {
                    id
                }
            }
            musicPlayers {
                id,
                name, 
                description,
                status,
                accessMinutes {
                    before, 
                    after
                },
                allowUserAccess,
                externalId,
                maximumVolume
                infrastructures {
                    id
                }
            }
            infrastructures {
                id,
                name, 
                description,
                slotNumber,
                most_active_circles {
                    circle {
                        id,
                        name
                    }
                }
                currentSportunity {
                    id,
                    title,
                    beginning_date,
                    ending_date,
                    organizers {
                        organizer {
                            id, pseudo
                        },
                        isAdmin
                    }
                }
                nextSportunity {
                    id,
                    title,
                    beginning_date,
                    ending_date,
                    organizers {
                        organizer {
                            id, pseudo
                        },
                        isAdmin
                    }
                }
            }
        }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/components/VenuePanel.js